import React, { useState, useEffect } from 'react';
import { InboxOutlined, CloseOutlined } from '@ant-design/icons';

const TOUR_KEY = 'biodata_tour_dismissed';

const BiodataTourHint = () => {
    const [visible, setVisible] = useState(false);
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(TOUR_KEY)) return;
        const t = setTimeout(() => setVisible(true), 2000);
        return () => clearTimeout(t);
    }, []);

    const dismiss = () => {
        setExiting(true);
        setTimeout(() => {
            setVisible(false);
            localStorage.setItem(TOUR_KEY, '1');
        }, 300);
    };

    if (!visible) return null;

    return (
        <>
            <style>{`
                @keyframes hm-tour-in {
                    from { opacity: 0; transform: translateY(24px) scale(0.96); }
                    to   { opacity: 1; transform: translateY(0)   scale(1);    }
                }
                @keyframes hm-tour-out {
                    from { opacity: 1; transform: translateY(0)   scale(1);    }
                    to   { opacity: 0; transform: translateY(16px) scale(0.96); }
                }
                @keyframes hm-drag-bounce {
                    0%, 100% { transform: translateY(0); }
                    40%      { transform: translateY(-6px); }
                }
                @keyframes hm-pulse-ring {
                    0%   { box-shadow: 0 0 0 0   rgba(173,20,87,0.35); }
                    70%  { box-shadow: 0 0 0 10px rgba(173,20,87,0);   }
                    100% { box-shadow: 0 0 0 0   rgba(173,20,87,0);    }
                }
            `}</style>
            <div style={{
                position: 'fixed',
                bottom: '28px',
                right: '24px',
                zIndex: 1100,
                maxWidth: '300px',
                width: 'calc(100vw - 48px)',
                background: 'white',
                borderRadius: '18px',
                boxShadow: '0 12px 40px rgba(173,20,87,0.18), 0 4px 12px rgba(0,0,0,0.08)',
                border: '1.5px solid rgba(173,20,87,0.15)',
                padding: '18px 20px 16px',
                animation: exiting
                    ? 'hm-tour-out 0.3s ease forwards'
                    : 'hm-tour-in 0.4s cubic-bezier(0.34,1.56,0.64,1) forwards',
                fontFamily: 'Calibri, sans-serif',
            }}>
                {/* Close button */}
                <button
                    onClick={dismiss}
                    style={{
                        position: 'absolute', top: '10px', right: '10px',
                        background: 'none', border: 'none', cursor: 'pointer',
                        color: '#94A3B8', padding: '4px', lineHeight: 1,
                        fontSize: '0.85rem',
                        transition: 'color 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.color = '#AD1457'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = '#94A3B8'; }}
                >
                    <CloseOutlined />
                </button>

                {/* Icon + text */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                    <div style={{
                        flexShrink: 0,
                        width: '44px', height: '44px', borderRadius: '12px',
                        background: 'linear-gradient(135deg,#AD1457,#D81B60)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        animation: 'hm-pulse-ring 2s ease-out infinite',
                    }}>
                        <InboxOutlined style={{
                            color: 'white', fontSize: '1.3rem',
                            animation: 'hm-drag-bounce 1.6s ease-in-out infinite',
                            display: 'inline-block',
                        }} />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#1A1A2E', marginBottom: '4px' }}>
                            Drop Your Biodata Here
                        </div>
                        <div style={{ fontSize: '0.83rem', color: '#64748B', lineHeight: 1.55 }}>
                            Drag &amp; drop your biodata file anywhere on this page to upload instantly.
                        </div>
                    </div>
                </div>

                {/* Got it button */}
                <button
                    onClick={dismiss}
                    style={{
                        marginTop: '14px',
                        width: '100%',
                        height: '36px',
                        background: 'linear-gradient(135deg,#AD1457,#D81B60)',
                        border: 'none', borderRadius: '10px',
                        color: 'white', fontWeight: 700, fontSize: '0.85rem',
                        fontFamily: 'Calibri, sans-serif',
                        cursor: 'pointer',
                        transition: 'opacity 0.2s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; }}
                    onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
                >
                    Got it!
                </button>
            </div>
        </>
    );
};

export default BiodataTourHint;
